module.exports = __webpack_public_path__ + "static/media/online-hero.882f3bb1.jpg";